import React, { useEffect, useState } from "react";
import AuthService from "services/auth.service";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import topUp from "../assets/img/money-receive-square.svg";
import pay from "../assets/img/money-receive-square red.svg";
import withdrawal from "../assets/img/money-send-square.svg";
import more from "../assets/img/elements.svg";
import Avatar from "components/Avatar";
import deposit from "../assets/img/deposit-icon.png";

import { API_URL_IMAGE } from "../services/config";
// react plugin used to create charts

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
} from "reactstrap";
// core components

import defaultImage from "../assets/img/default-avatar.png";
import authHeader from "services/auth-header";
import DepositModal from "components/DepositModal";
import "../components/WithdrawalModal.css";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const getLightVariant = (color) => {
  const lightenFactor = 0.7; // Adjust this factor as needed
  return color.replace(
    /^#/,
    (match) =>
      "#" +
      match
        .slice(1)
        .replace(/../g, (color) =>
          (
            "0" +
            Math.min(255, parseInt(color, 16) * lightenFactor).toString(16)
          ).slice(-2)
        )
  );
};

const TransactionItem = ({ title, totalFee, refundableFee, status }) => {
  const firstLetter = title.charAt(0).toUpperCase();
  const textColor = "#333"; // Dark text color
  const bgColor = getRandomColor();
  const lightBgColor = getLightVariant(bgColor);

  const roundImageStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    color: "white",
    display: "inline-flex", // Display as inline-flex to have them side by side
    alignItems: "center",
    justifyContent: "center",
    padding: "5px", // Add padding for better spacing
    marginRight: "10px",
  };

  const textStyle = {
    // background: `linear-gradient(90deg, ${lightBgColor} 100%, transparent 100%)`,
    padding: "10px",
    borderRadius: "5px",
    color: "#222", // Dark text color
  };

  return (
    <td className="text-title">
      <div className="box-box">
        <div style={roundImageStyle} className="ball-mob">
          {firstLetter}
        </div>
      </div>
      <span style={textStyle}>{title}</span>
    </td>
  );
};

function Dashboard() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
  const [masked, setMasked] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [status, setStatus] = useState("");
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);

  //const [showModal, setShowModal] = useState(false);
  const tcc = currentUser.tcc;
  const toggleMask = () => {
    setMasked((prevMasked) => !prevMasked);
  };

  useEffect(() => {
    const fetchStatus = () => {
      AuthService.getStatus(currentUser.id)
        .then((response) => {
          setStatus(response.data.status);
        })
        .catch((e) => {
          //console.log(e);
        });
    };

    fetchStatus(); // Fetch status initially
    const interval = setInterval(fetchStatus, 60000); // Fetch status every 60 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [currentUser.id]);

  useEffect(() => {
    checkNotification();
    retrieveTransaction();
  }, []);

  //logic to use local storage to prevent showing nnotification multiple times

  const checkNotification = () => {
    const seenNotification = localStorage.getItem("hasSeenNotification");
    if (!seenNotification) {
      fetchNotification();
    }
  };
  const retrieveTransaction = () => {
    AuthService.getAllTransaction(id)
      .then((response) => {
        // Sort transactions by createdAt date, newest first
        const sortedTransactions = response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTransaction(sortedTransactions);
        console.log("Transactions loaded:", sortedTransactions);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // logic to fetch the pop-up for the notification
  const fetchNotification = () => {
    AuthService.fetchNotification(id)
      .then((response) => {
        setNotifications(response.data);
        showNotifications(response.data);
        localStorage.setItem("hasSeenNotification", "true"); // Mark as seen after displaying toasts
      })
      .catch((error) => console.error("Error fetching notification:", error));
  };

  // Function to show notifications one by one
  const showNotifications = (notifications) => {
    let index = 0;

    const showNextNotification = () => {
      if (index < notifications.length) {
        const notification = notifications[index];
        if (!notification.read) {
          toast.warn(
            <p>
              <b>{notification.title}</b> <br /> {notification.message}{" "}
            </p>,
            {
              position: "bottom-right",
              autoClose: 7000, // Adjust time as needed
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              onClose: () => markNotificationAsRead(notification.id), //mark as read after displaying
            }
          );
        }
        index++;
        setTimeout(showNextNotification, 4000); // Delay for next notification
      }
    };

    showNextNotification();
  };

  // Function to mark a notification as read
  const markNotificationAsRead = (notificationId) => {
    AuthService.markNotificationAsRead(notificationId)
      .then(() => {
        //console.log(`Notification ${notificationId} marked as read`);
      })
      .catch((error) =>
        console.error("Error marking notification as read:", error)
      );
  };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  //   localStorage.setItem("hasSeenNotification", "true");
  // };






  // New function to handle withdrawal/claim refunds click
  const handleWithdrawalClick = () => {
    const pendingPayment = parseFloat(currentUser.pendingPayment) || 0;

    if (pendingPayment > 0) {
      // Show withdrawal modal with pending balance info
      setShowWithdrawalModal(true);
    } else {
      // If no pending payment, redirect to support for withdrawal
      window.location.href = "/user/notifications";
    }
  };

  // Function to handle "Pay Now" action
  const handlePayNow = () => {
    setShowWithdrawalModal(false);
    setShowDepositModal(true);
  };

  const closeWithdrawalModal = () => {
    setShowWithdrawalModal(false);
  };

  const handleWithdrawalBackdropClick = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      closeWithdrawalModal();
    }
  };

  //logic for profile image

  const imageDir = currentUser.imageURL;
  let profileImage = `${API_URL_IMAGE}${imageDir}`;

  // Check if imageURL ends with 'none', if yes, use the default image
  if (profileImage.endsWith("none")) {
    profileImage = defaultImage;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short" }; // Using 'short' to get abbreviated month names
    return date.toLocaleDateString("en-US", options);
  };


  // Calculate pending payment amount
  const pendingPayment = parseFloat(currentUser.pendingPayment) || 0;
  const hasPendingPayment = pendingPayment > 0;

  return (
    <>
      <ToastContainer newestOnTop={false} />
      <div className="content mid-content">
        <Row>
          <Col lg="12" md="6" sm="6" className="house-all">
            <div className="typography-line-dash  line-dash-mob">
              <h2>Hi {currentUser.firstName}</h2>
            </div>
            <div className="avatar avatar-mob">
              <img
                alt="..."
                className="img-circle img-no-padding img-responsive"
                //src={require("assets/img/faces/mil.jpg")}
                src={profileImage}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="12" md="10" sm="6">
            <Card className="card-stats dash-green">
              <CardBody>
                <Row className="innercol">
                  <Col className="adjust">
                    <div class="card-elipse">
                      <div class="ellipse top-right"></div>
                      <div class="ellipse bottom-left"></div>
                      <div class="content">
                        <div className="taggg">
                          <h2 className="escrow-textttt">Escrow Balance</h2>
                          <div
                            className={`status-badge ${status.toUpperCase()
                              }`}
                          >
                            <div
                              className={`status-dot ${status.toUpperCase()
                                }`}
                            ></div>
                            {status}
                          </div>
                        </div>

                        <p class="amount big-amount">
                          {isNaN(parseFloat(currentUser.availableBalance))
                            ? "0.00"
                            : new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(
                              parseFloat(currentUser.availableBalance)
                            )}
                        </p>
                        <p class="tag-name">TCC Number</p>
                        <p
                          className={`number ${masked ? "masked" : ""}`}
                          onClick={toggleMask}
                        >
                          {masked ? "**** **** **** " : tcc}
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col className="adjust zincy">
                    <div class="balance-card">
                      <h2>Balances</h2>
                      <div class="balance-sections">
                        <div class="balance-section refundable">
                          <p className="refP">Refundable Balance</p>
                          <p class="amount positive">
                            {" "}
                            +
                            {isNaN(
                              parseFloat(currentUser.transactionRefundableFee)
                            )
                              ? "0.00"
                              : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(
                                  currentUser.transactionRefundableFee
                                )
                              )}
                          </p>
                        </div>
                        <div class="balance-section pending">
                          <p className="refP">Pending Charge</p>
                          <p class="amount negative">
                            {" "}
                            {isNaN(parseFloat(currentUser.pendingPayment))
                              ? "0.00"
                              : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(currentUser.pendingPayment)
                              )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col className="adjust zincy">
                    <div class="balance-card">
                      <h2>Quick Actions</h2>
                      <div class="balance-sections">
                        <div className="quick-actions">
                          <Link to={"/user/notifications"} className="">
                            <img src={topUp} />
                            <p
                              style={{ color: "white", textDecoration: "none" }}
                            >
                              Notification
                            </p>
                          </Link>
                        </div>

                        <div className="quick-actions"
                          onClick={() => setShowDepositModal(true)}
                        >
                          <img src={pay} />
                          <p
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Pay
                          </p>

                        </div>


                        <div className="quick-actions tooltippp"
                          onClick={handleWithdrawalClick}
                        >
                          <img src={withdrawal} />
                          <p>Withdrawal</p>
                          <span className="tooltippp-text">
                            Available when approved
                          </span>
                        </div>
                        <div className="quick-actions">
                          <img src={more} />
                          <p>More</p>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col className="adjust adjust-mob">
                    <div class="balance-card">
                      <div class="balance-sections">
                        <div class="balance-section refundable">
                          <p className="refP">Refundable Balance</p>
                          <p class="amount positive">
                            {" "}
                            +
                            {isNaN(
                              parseFloat(currentUser.transactionRefundableFee)
                            )
                              ? "0.00"
                              : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(
                                  currentUser.transactionRefundableFee
                                )
                              )}
                          </p>
                        </div>
                        <div class="balance-section pending">
                          <p className="refP">Pending Charge</p>
                          <p class="amount negative">
                            {" "}
                            {isNaN(parseFloat(currentUser.pendingPayment))
                              ? "0.00"
                              : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(currentUser.pendingPayment)
                              )}
                          </p>
                        </div>
                      </div>
                      <div class="balance-sections">
                        <div className="quick-actions">
                          <Link to={"/user/notifications"}>
                            <img src={topUp} />
                            <p
                              style={{ color: "white", textDecoration: "none" }}
                            >
                              Notification
                            </p>
                          </Link>
                        </div>

                        <div className="quick-actions"
                          onClick={() => setShowDepositModal(true)}>
                          <img src={pay} />
                          <p
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            Pay
                          </p>
                        </div>
                        <div className="quick-actions tooltippp"
                          onClick={handleWithdrawalClick}>
                          <img src={withdrawal} />
                          <p>Withdrawal</p>
                          <span className="tooltippp-text">
                            Available when approved
                          </span>
                        </div>
                        <div className="quick-actions ">
                          <img src={more} />
                          <p>More</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg="12" md="6" sm="6">
            <div className="typography-line-dash">
              <h3>Transactions</h3>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <Card className="outer-line hideeee">
              <CardHeader>
                <CardTitle tag="h4">Transactions</CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr className="table-head">
                      <th>Transaction</th>
                      <th>Total Fee Cost (Non Refundable)</th>
                      <th>Refundable Fee</th>
                      <th className="">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transaction.slice(0, 3).map((transaction, index) => (
                      <tr
                        key={transaction.id}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {/* <td className="text-title">{transaction.title}</td> */}
                        <TransactionItem
                          title={transaction.title}
                          totalFee={transaction.totalFee}
                          refundableFee={transaction.refundableFee}
                          status={transaction.status}
                        />
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(transaction.totalFee))}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(transaction.refundableFee))}
                        </td>
                        <td className="text-status">
                          <div
                            className={`text-status-${transaction.status ? "paid" : "pending"
                              }`}
                          >
                            {transaction.status ? "Paid" : "Pending"}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Link to={"/user/tables"}>
                    <Button className=" overide">View All Transactions</Button>
                  </Link>
                </div>
              </CardBody>
            </Card>

            <div className="outer-line bod">
              <div className="jag-transaction-list tran-mob">
                <CardBody className="jag-tran-card">
                  {transaction.slice(0, 3).map((transaction) => (
                    <div key={transaction.id} className="jag-transaction-item">
                      <div className="jag-transaction-info">
                        <div className="jag-transaction-icon">
                          <Avatar text={transaction.title} />
                        </div>
                        <div>
                          <div className="jag-transaction-type">
                            {transaction.title}
                          </div>
                          <div className="jag-transaction-time">
                            {formatDate(transaction.createdAt)}
                          </div>
                        </div>
                      </div>
                      <div className="jag-transaction-details">
                        <div className="jag-transaction-amount">
                          +
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(transaction.totalFee))}
                        </div>
                        <div
                          className="jag-status"
                          style={{
                            color: transaction.status ? "green" : "yellow",
                          }}
                        >
                          {transaction.status ? "Paid" : "Pending"}
                        </div>
                      </div>
                    </div>
                  ))}
                </CardBody>
                <br />
                <br />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Link to={"/user/tables"}>
                    <Button className=" overide">View All Transactions</Button>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {/* {showModal && (
          <NotificationModal
            notifications={notifications}
            onClose={handleCloseModal}
          />
        )} */}



        {/* Withdrawal/Claim Refunds Modal */}
        {showWithdrawalModal && (
          <div
            className="modal-backdrop"
            onClick={handleWithdrawalBackdropClick}
          >
            <div className="modal-content withdrawal-modal">
              <button className="close-button" onClick={closeWithdrawalModal}>
                ×
              </button>

              <div className="withdrawal-header">
                <img src={deposit} alt="Information" className="info-icon" />
                <h3>{hasPendingPayment ? "Claim Refunds" : "Withdraw Funds"}</h3>
              </div>

              <div className="withdrawal-notice">
                {hasPendingPayment ? (
                  <>
                    <div className="pending-balance-alert">
                      <div className="alert-icon">⚠️</div>
                      <div className="alert-content">
                        <h4>Outstanding Balance Due</h4>
                        <p className="pending-amount">
                          You have an outstanding balance of{" "}
                          <strong>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(pendingPayment)}
                          </strong>
                        </p>
                      </div>
                    </div>

                    <div className="notice-points">
                      <div className="notice-point">
                        <p>
                          <strong>Clear Outstanding Balance:</strong> Before you can withdraw funds or claim refunds, you must clear your outstanding balance of{" "}
                          <strong>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(pendingPayment)}
                          </strong>
                        </p>
                      </div>

                      <div className="notice-point">
                        <p>
                          <strong>Refund Eligibility:</strong> Your refundable balance of{" "}
                          <strong>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(parseFloat(currentUser.transactionRefundableFee) || 0)}
                          </strong>{" "}
                          will become available for withdrawal once all pending payments are cleared.
                        </p>
                      </div>

                      <div className="notice-point">
                        <p>
                          <strong>Payment Methods:</strong> You can pay your outstanding balance using any of our available deposit methods including cryptocurrency, P2P payments, or gift cards.
                        </p>
                      </div>
                    </div>

                    <div className="balance-summary">
                      <div className="balance-item">
                        <span>Outstanding Balance:</span>
                        <span className="amount negative">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(pendingPayment)}
                        </span>
                      </div>
                      <div className="balance-item">
                        <span>Refundable Balance:</span>
                        <span className="amount positive">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(currentUser.transactionRefundableFee) || 0)}
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="no-pending-balance">
                    <div className="success-icon">✅</div>
                    <h4>No Outstanding Balance</h4>
                    <p>Your account is in good standing. You can proceed with withdrawals.</p>

                    <div className="balance-summary">
                      <div className="balance-item">
                        <span>Available for Withdrawal:</span>
                        <span className="amount positive">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(currentUser.transactionRefundableFee) || 0)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="withdrawal-actions">
                {hasPendingPayment ? (
                  <>
                    <button
                      className="primary-btn pay-now-btn"
                      onClick={handlePayNow}
                    >
                      Pay Outstanding Balance
                    </button>
                    <button
                      className="secondary-btn"
                      onClick={closeWithdrawalModal}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <button
                    className="primary-btn"
                    onClick={() => {
                      closeWithdrawalModal();
                      window.location.href = "/user/notifications";
                    }}
                  >
                    Proceed to Withdrawal
                  </button>
                )}
              </div>

              <div className="contact-support">
                <p>
                  Need assistance? Our <a href="/user/notifications">support team</a> is available to help with any questions regarding your account balance or payment process.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Deposit Modal */}
        {showDepositModal && (
          <DepositModal
            isOpen={showDepositModal}
            onClose={() => setShowDepositModal(false)}
          />
        )}
      </div>




    </>
  );
}

export default Dashboard;
